const validate = values => {
    const errors = {};
    const message = 'Campo requerido';

    // Validate the 'name' field
    if (!values.name) {
        errors.name = message;
    }

    if (Array.isArray(values.investments_budget_row)) {
        const investmentsRowErrors = values.investments_budget_row.map((row, index) => {
            const rowErrors = {};

            if (!row.name) {
                rowErrors.name = message;
            }
            // Retornar el objeto de errores (puede estar vacío) para mantener las posiciones
            return Object.keys(rowErrors).length ? rowErrors : {};
        });

        // Solo asignar errores si alguna fila tiene errores
        const hasErrors = investmentsRowErrors.some(rowErrors => Object.keys(rowErrors).length > 0);
        if (hasErrors) {
            errors.investments_budget_row = investmentsRowErrors;
        }
    }

    return errors;
};

export default validate;
